import { Box } from "@mui/material";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import WarehouseManagementMenu from "../features/warehouse/WarehouseMenu";
import WarehouseIndex from "../features/warehouse/WarehouseList";
import WarehouseNewManagementMenu from "../features/warehousenew/WarehouseNewMenu";

import WarehouseTypeIndex from "../features/warehousenew/masterwarehousetype/WarehouseTypeIndex";
import WarehouseEnvironmentIndex from "../features/warehousenew/masterwarehouseenvironment/WarehouseEnvironmentIndex";

import WHLocationTypeIndex from "../features/warehousenew/masterwarehouselocationtype/WHLocationTypeIndex";
import WarehouseObjectTypeSizeMasterIndex from "../features/warehousenew/masterwarehouseobjectmaster/WarehouseObjectTypeSizeMasterIndex";
import WarehouseMaster from "../features/warehousenew/warehouse-master/WarehouseMaster";

import BintypeMaster from "../features/warehousenew/bintype-master/BintypeMaster";

import StorageLocation from "../features/warehousenew/storage-location/StorageLocation";

import WarehouseMappingMasterIndex from "../features/warehousenew/masterwarehousemapping/WarehouseMappingMasterIndex";
import WarehouseReport from "../features/warehousenew/reports/WarehouseReport";
import WarehouseMasterDataReport from "../features/warehousenew/warehouse-data-report/WarehouseDataReport";
import UserGuideList from "../features/user-guide/UserGuideList";
import WarehouseDashboard from "../features/warehousenew/dashboard/WarehouseDashboard";


const WarehouseNewManagement = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }
    return (
        <Box position="relative">
            {activePage === "ViewMainPage" && (<WarehouseNewManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}

       
            {activePage === "Warehouse" && (
                <WarehouseMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} reelID={0} />
            )}

           
            {activePage === "WarehouseType" && (
                <WarehouseTypeIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseEnvironmentType" && (
                <WarehouseEnvironmentIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "BinTypeMaster" && (
                <BintypeMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseLocationType" && (
                <WHLocationTypeIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseObjectSizeType" && (
                <WarehouseObjectTypeSizeMasterIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "StorageLocation" && (
                <StorageLocation handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseMapping" && (
                < WarehouseMappingMasterIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseReport" && (
                <WarehouseReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "WarehouseMasterReport" && (
                <WarehouseMasterDataReport handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "user-guide" && (
                <UserGuideList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

             {activePage === "WarehouseDashboard" && (
                <WarehouseDashboard handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            

            {/* <AddWarehouseDetails/> */}
            {/* <WarehouseForm/> */}
            {/* <ReelCalculator/> */}
            {/* <AllocateLocationForReel /> */}

        </Box>

    );

};
export default WarehouseNewManagement;